/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Rectangle } from 'pixi.js-legacy';
import { Subject } from 'rxjs';

// window types, it's only used for ticket edit now
export enum WindowType {
	TicketEdit = 'ticketEdit',
}

// this currently works with attribute directive PositionTracker
// ticket edit component could be either one of following
export enum NodeType {
	TaskEdit = 'TASK-EDIT',
	MilestoneEdit = 'MILESTONE-EDIT',
	ConstraintEdit = 'CONSTRAINT-EDIT',
	MultiEditTask = 'MULTI-EDIT-TASK',
	MultiEditMilestone = 'MULTI-EDIT-MILESTONE',
	MultiEditConstraint = 'MULTI-EDIT-CONSTRAINT',
}

// used as value in typeMap below
const ALL_TICKET_EDIT_NODE_TYPES = [
	NodeType.TaskEdit,
	NodeType.MilestoneEdit,
	NodeType.ConstraintEdit,
	NodeType.MultiEditTask,
	NodeType.MultiEditMilestone,
	NodeType.MultiEditConstraint,
]; // as const;
// type TICKET_EDIT_TUPLE = typeof ALL_TICKET_EDIT_NODE_TYPES;
// export type TICKET_EDIT_NODES_TYPES = TICKET_EDIT_TUPLE[number]; // union type

@Injectable()
/*
 * This might be an overkill for now. but the idea is to track the position of ticket edit windows,
 * incl. task, milestone etc. so we can align other windows with them. (align cycle ticket with ticket edit)
 * Right now ALL_TICKET_EDIT_NODE_TYPES all have the same type of TICKET_EDIT.
 * Keeping this data structure to be future proof, e.g. track multi-select-menu or undo panel
 */
export class PositionManagerService {
	public positions: Map<WindowType, Subject<Rectangle>>;
	private typeMap: Map<WindowType, NodeType[]>;
	private positionMap: Map<string, Rectangle>;

	constructor() {
		this.positions = new Map<WindowType, Subject<Rectangle>>();
		this.typeMap = new Map<WindowType, NodeType[]>();
		this.positionMap = new Map<string, Rectangle>();

		this.positions.set(WindowType.TicketEdit, new Subject());
		this.typeMap.set(WindowType.TicketEdit, ALL_TICKET_EDIT_NODE_TYPES);
	}

	// get window position - non-observable way, if ever needed
	public getPosition(type: string): Rectangle {
		return this.positionMap.get(type);
	}

	// set window position, overwrites if exists
	public setPosition(type: string, rect: Rectangle): void {
		this.positionMap.set(type, rect);

		for (const key of Array.from(this.typeMap.keys())) {
			if (this.typeMap.get(key).includes(type as NodeType)) {
				this.positionMap.set(key, rect);
				this.positions.get(key).next(rect);
				break;
			}
		}
	}
}
